export default "__VITE_ASSET__CpS_KFJw__"